module.exports = __webpack_public_path__ + "static/media/bikes_treadmill.d27b9abd.png";